import {Component, OnInit} from '@angular/core';
import {SearchService} from '../search.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {AppConfigService} from '../../config/app-config.service';
import {AbstractSearchListComponent} from './abstract-search-list/abstract-search-list.component';
import {HtmlUtilsService} from '../../html-utils/html-utils.service';
import {UserCollectionsService} from '../../auth/account/user-collections/user-collections.service';
import {AuthService} from '../../auth/auth.service';
import {TranslateService} from '../../shared/translate.service';
import {FiltersService} from './filters/filters.service';
import {UserQueriesService} from '../../auth/account/user-queries/user-queries.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../messages/message.service';


@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.css']
})
export class SearchListComponent extends AbstractSearchListComponent implements OnInit {

  constructor(protected router: Router, route: ActivatedRoute, searchService: SearchService,
              appConfigService: AppConfigService, protected htmlUtils: HtmlUtilsService,
              protected userCollectionsService: UserCollectionsService, protected userQueriesService: UserQueriesService,
              protected authService: AuthService, protected filterService: FiltersService,
              protected translateService: TranslateService, protected modalService: NgbModal,
              protected messageService: MessageService) {
    super(route, searchService, appConfigService, htmlUtils, userCollectionsService, userQueriesService, authService,
      filterService, translateService, modalService, messageService, router);
  }

  ngOnInit() {
    super.ngOnInit();
    this.route.queryParamMap.subscribe(
      params => {
        this.search(params);
      }
    );
  }

  search(params: ParamMap) {
    this.inProgress = true;
    let paramObject = SearchService.prepareParamsObject(params, this.appConfigService);
    this.find(
      paramObject.phrase, paramObject.page, paramObject.pageSize, paramObject.sort, paramObject.filters,
      paramObject.searchInText, paramObject.collectionId, paramObject.queryId);
  }
}
